import { useEffect, useState } from 'react';

const DEFAULT_PER_PAGE = 25;

type PaginationParams = {
  resetOn?: readonly unknown[];
  initialPerPage?: number;
};

type Pagination = {
  page: number;
  setPage: (page: number) => void;
  perPage: number;
  setPerPage: (perPage: number) => void;
};

export const usePagination = ({
  resetOn = [],
  initialPerPage = DEFAULT_PER_PAGE,
}: PaginationParams = {}): Pagination => {
  const [page, setPage] = useState(0);
  const [perPage, setPerPageState] = useState(initialPerPage);

  const setPerPage = (next: number): void => {
    setPerPageState(next);
    setPage(0);
  };

  useEffect(() => {
    setPage(0);
  }, resetOn);

  return { page, setPage, perPage, setPerPage };
};

type EmptyPageGuardParams = Pick<Pagination, 'page' | 'setPage'> & {
  itemCount: number;
  isFetching: boolean;
};

export const useEmptyPageGuard = ({
  page,
  setPage,
  itemCount,
  isFetching,
}: EmptyPageGuardParams): void => {
  useEffect(() => {
    if (page > 0 && !isFetching && itemCount === 0) {
      setPage(page - 1);
    }
  }, [page, isFetching, itemCount]);
};
